export default __webpack_public_path__ + "static/media/01.da1fdf19.jpg";